import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { storyTellerActions } from '../../actions';
import {
  FillMoreStoryMessagesActionPayload,
  LoadMoreStoryMessagesActionPayload,
} from '../../typedefs';

export function* loadMoreStoryMessages({
  payload,
}: PayloadAction<LoadMoreStoryMessagesActionPayload>) {
  try {
    yield effects.put(storyTellerActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: payload.url, direct: true },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    const data: FillMoreStoryMessagesActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(
      storyTellerActions.fillMoreStoryMessages({
        data,
        chatId: payload.chatId,
      }),
    );
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(storyTellerActions.stopFetching());
  }
}
